import { fromJS, List, Map, Record } from 'immutable';
import simpleReducer from '../common/utils/simple-reducer';
import { SET_CURRENT_PROJECT } from '../project/action-types';
import { createPublishTarget, fetchPublishTargets, fetchUser, unlink } from './actions';

const emptyMap = Map();
const emptyList = List();

export const IntegrationsState = new Record({
  data: emptyMap,
  providers: fromJS({
    netlify: {
      accountUrl: 'https://app.netlify.com/account'
    },
    vercel: {
      accountUrl: 'https://vercel.com/dashboard'
    }
  })
});

const initialState = new IntegrationsState();

const handleRoutine = (routine, type) => ({
  [routine.REQUESTED]: (state, { meta }) =>
    state.mergeIn(
      ['data', meta.provider, type],
      Map({
        loading: true,
        error: undefined
      })
    ),
  [routine.FULFILLED]: (state, { payload, meta }) =>
    state.mergeIn(
      ['data', meta.provider, type],
      Map({
        loading: false,
        loaded: true,
        error: undefined,
        data: fromJS(payload.data)
      })
    ),
  [routine.REJECTED]: (state, { payload, meta }) =>
    state.mergeIn(
      ['data', meta.provider, type],
      Map({
        loading: false,
        loaded: true,
        data: undefined,
        error: Map({
          status: payload.statusCode,
          message: payload.response
        })
      })
    )
});

export default simpleReducer(initialState, {
  ...handleRoutine(fetchUser, 'user'),
  ...handleRoutine(fetchPublishTargets, 'publishTargets'),
  [createPublishTarget.FULFILLED]: (state, { payload, meta }) =>
    state.updateIn(['data', meta.provider, 'publishTargets', 'data'], (v = emptyList) =>
      v.unshift(fromJS({ ...payload.data, thumb: null }))
    ),
  [unlink]: (state, { payload }) => state.setIn(['data', payload.provider], emptyMap),
  [SET_CURRENT_PROJECT]: () => initialState
});
